import { MapContext } from 'components/Mapbox/Mapbox'
import { CTRLPositions } from 'components/Mapbox/Types/mapboxtypes'
import mapboxgl from 'mapbox-gl'
import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { CustomControl } from '../Utils/CreateCustomControl'

const PerspectiveControlDefaults: {
  position: CTRLPositions
  pitch3D: number
  zoom3D: number
} = {
  position: 'top-right',
  pitch3D: 60,
  zoom3D: 11,
}
export const PerspectiveControl = ({
  position = PerspectiveControlDefaults.position,
}: {
  position?: CTRLPositions
}) => {
  const [ctrlcontainer, setCtrlcontainer] = useState<any | null>(null)
  const [control, setControl] = useState<CustomControl | undefined>(undefined)
  var context = useContext(MapContext)
  var className = 'perspective-control'
  const [added, setAdded] = useState(false)

  useEffect(() => {
    if (!context.map || !context.setTerrain) return

    const _ctrlcontainer = context.map
      .getContainer()
      .getElementsByClassName(className)

    if (_ctrlcontainer.length > 0) return
    var container = document.createElement('div')
    setCtrlcontainer(container)
  }, [context.map, context.setTerrain])

  function addControl() {
    if (!context.map || !context.setTerrain) return
    var ctrl = new CustomControl(
      context.setTerrain,
      context.map,
      <FSButton onClick={context.setTerrain} map={context.map} />,
      className
    )
    setControl(ctrl)
    context.map.addControl(ctrl, position)
    setAdded(true)
  }

  function removeControl() {
    if (!context.map || !control) return
    context.map.removeControl(control)
  }

  useEffect(() => {
    // if (added) removeControl()
    if (added) return
    addControl()
  }, [position, ctrlcontainer, context.terrainActive])

  return null
}

const FSButton = ({
  onClick,
  map,
}: {
  onClick?: (a: boolean) => void | undefined
  map: mapboxgl.Map
}) => {
  var context = useContext(MapContext)
  const [active, setActive] = useState(!!context.terrainActive)

  useEffect(() => {
    console.log('---TERRAIN CHANGED', context.terrainActive)

    context.terrainActive && setActive(!!context.terrainActive)
  }, [context.terrainActive])
  useEffect(() => {
    if (!map) return
    if (active) {
      map.flyTo({
        center: map.getCenter(),
        zoom: 11.5,
        bearing: map.getBearing(),
        pitch: PerspectiveControlDefaults.pitch3D,
      })
      // map.setPitch(PerspectiveControlDefaults.pitch3D)
      // map.setZoom(Math.min(map.getMaxZoom(), PerspectiveControlDefaults.zoom3D))
    }
    if (!active)
      map.flyTo({
        center: map.getCenter(),
        zoom:  map.getZoom(),
        bearing:0,
        pitch: 0,
      })
  }, [active])

  useEffect(() => {
    onClick && onClick(!!context.terrainActive)
  }, [active])

  return (
    <ControlButton
      className='control-button'
      style={{ pointerEvents: 'all', position: 'relative', width: '30px' }}
      onClick={() => setActive(!active)}
    >
      <>
        {!active && <>3D</>}
        {active && <>2D</>}
      </>
    </ControlButton>
  )
}

const ControlButton = styled.button``
